// (function() {
//   const filtersWrapper = document.querySelector('.plant-finder__strings');
//   const collectionWrapper = document.querySelector('.main-collection-wrapper');
//   const collectionFiltersForm = collectionWrapper?.querySelector('collection-filters-form');

//   if (!filtersWrapper) return;

//   window.addEventListener('click', (e) => {
//     filtersWrapper.querySelectorAll('.plant-finder__string-filters').forEach((el) => {
//       const withinBoundaries = e.composedPath().includes(el);

//       if (!withinBoundaries) {
//         if ( el.classList.contains('active')) {
//           el.classList.remove('active');
//         }
//       }
//     });
//   });

//   filtersWrapper.addEventListener('click', (e) => {
//     if (e.target.closest('.plant-finder__filter-selector-item') || e.target.classList.contains('plant-finder__filter-selector-item')) {
//       const target = e.target.closest('.plant-finder__filter-selector-item') || e.target;
//       const filterWrapper = target.closest('.plant-finder__string-filters');
//       const input = filterWrapper?.querySelector('.plant-finder__current-filter span');

//       if (!filterWrapper || target.classList.contains('active') || !input) return;

//       filterWrapper.querySelector('.plant-finder__filter-selector-item.active')?.classList.remove('active');
//       target.classList.add('active');
//       filterWrapper.classList.remove('active');

//       input.textContent = target.dataset.value;
//       filterWrapper.dataset.filterValue = target.dataset.value
//     } else if (e.target.closest('.plant-finder__string-filters') || e.target.classList.contains('plant-finder__string-filters')) {
//       const target = e.target.closest('.plant-finder__string-filters') || e.target;
//       target.classList.toggle('active');
//     }

//     if (e.target.closest('.plant-finder__submit') || e.target.classList.contains('plant-finder__submit')) {
//       const selectedFilters = filtersWrapper.querySelectorAll('.plant-finder__string-filters[data-filter-value][data-tag-name]');
//       const filterHrefParams = [];

//       selectedFilters.forEach((el) => {
//         let filterParam = 'filter.p.tag=' + el.dataset.tagName.split(' ').join('+');
//         filterParam = filterParam + '_' + el.dataset.filterValue.split(' ').join('+');

//         filterHrefParams.push(filterParam);
//       });

//       if (filterHrefParams.length === 0) return;

//       if (collectionFiltersForm) {
//         collectionFiltersForm.renderPage(filterHrefParams.join('&'));
//         collectionWrapper.scrollIntoView({ 'behavior': 'smooth' });
//         collectionWrapper.classList.add('visible');
//       } else {
//         window.location.href = window.location.href.split('?')[0] + '?' + filterHrefParams.join('&');
//       }
//     }
//     if (e.target.closest('.plant-finder__reset') || e.target.classList.contains('plant-finder__reset')) {
//       // remove the filters
//       // remove the text in the "input field"
//       // do not reload the page but clear the hrefparams
//     }
//   });
// })();

(() => {
  const filters = document.querySelector('.plant-finder__strings');
  if (!filters) return;

  const collection = document.querySelector('.main-collection-wrapper');
  const ajaxForm = collection?.querySelector('collection-filters-form');
  const baseUrl = location.href.split('?')[0];

  const token = s => (s || '').trim().replace(/\s+/g, '+');

  function buildQuery() {
    return [...filters.querySelectorAll('.plant-finder__string-filters[data-filter-value][data-tag-name]')]
      .map(el => `filter.p.tag=${token(el.dataset.tagName)}_${token(el.dataset.filterValue)}`)
      .join('&');
  }

  function applyQuery(qs, { scroll = true } = {}) {
    if (ajaxForm?.renderPage) {
      ajaxForm.renderPage(qs || '');
      history.replaceState?.({}, '', qs ? `${baseUrl}?${qs}` : baseUrl);
      if (scroll && qs) {
        collection?.scrollIntoView({ behavior: 'smooth' });
        collection?.classList.add('visible');
      }
    } else {
      if (qs) location.href = `${baseUrl}?${qs}`;
      else history.replaceState?.({}, '', baseUrl);
    }
  }

  function resetAll() {
    for (const fw of filters.querySelectorAll('.plant-finder__string-filters')) {
      fw.removeAttribute('data-filter-value');
      const select = fw.querySelector('select.plant-finder__select');
      if (select) select.value = '';
      fw.classList.remove('active');
    }
    applyQuery('', { scroll: false });
  }

  // Handle select changes
  filters.addEventListener('change', e => {
    const select = e.target.closest('select.plant-finder__select');
    if (!select) return;
    const box = select.closest('.plant-finder__string-filters');
    if (!box) return;
    if (select.value) {
      box.dataset.filterValue = select.value;
    } else {
      box.removeAttribute('data-filter-value');
    }
  });

  // Submit + Reset
  document.addEventListener('click', e => {
    const submit = e.target.closest('.plant-finder__submit');
    if (submit) { e.preventDefault(); const qs = buildQuery(); if (qs) applyQuery(qs, { scroll: true }); }

    const reset = e.target.closest('.plant-finder__reset');
    if (reset) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      resetAll();
    }
  }, { capture: true });
})();

// (function() {
//   const filtersWrapper = document.querySelector('.plant-finder__strings');
//   const collectionWrapper = document.querySelector('.main-collection-wrapper');
//   const collectionFiltersForm = collectionWrapper?.querySelector('collection-filters-form');

//   const filters = filtersWrapper.querySelectorAll('.plant-finder__string-filters');

//   for (let filter of filters){
//     filter.addEventListener('click', () => {
//       filter.classList.toggle('active');
      
//     })
//   }

//   window.addEventListener('click', (e) => {
//     filtersWrapper.querySelectorAll('.plant-finder__string-filters').forEach((el) => {
//       const withinBoundaries = e.composedPath().includes(el);

//       if (!withinBoundaries) {
//         if ( el.classList.contains('active')) {
//           el.classList.remove('active');
//         }
//       }
//     });
//   });
// })();

// (function () {
//   'use strict';

//   // Helpers
//   function select(sel, root) { return (root || document).querySelector(sel); }
//   function selectAll(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
//   function toToken(text) { return (text || '').trim().replace(/\s+/g, '+'); }
//   function baseUrl() { return window.location.href.split('?')[0]; }

//   // Elements
//   var filtersWrapper = select('.plant-finder__strings');
//   if (!filtersWrapper) return;

//   var collectionWrapper = select('.main-collection-wrapper');
//   var collectionFiltersForm = collectionWrapper ? collectionWrapper.querySelector('collection-filters-form') : null;

//   // Remember initial labels for reset
//   selectAll('.plant-finder__string-filters', filtersWrapper).forEach(function (fw) {
//     var span = select('.plant-finder__current-filter span', fw);
//     if (span && !fw.dataset.initialLabel) fw.dataset.initialLabel = span.textContent.trim();
//   });

//   // Build query from your custom UI
//   function buildQuery() {
//     var parts = [];
//     selectAll('.plant-finder__string-filters[data-filter-value][data-tag-name]', filtersWrapper).forEach(function (el) {
//       var tag = toToken(el.dataset.tagName);
//       var val = toToken(el.dataset.filterValue);
//       if (tag && val) parts.push('filter.p.tag=' + tag + '_' + val);
//     });
//     return parts.join('&');
//   }

//   // Apply query (AJAX if Shopify component exists, otherwise full reload)
//   function applyQuery(query) {
//     var q = query || '';
//     if (collectionFiltersForm && typeof collectionFiltersForm.renderPage === 'function' && q) {
//       collectionFiltersForm.renderPage(q);
//       if (history && history.replaceState) history.replaceState({}, '', baseUrl() + '?' + q);
//       if (collectionWrapper && collectionWrapper.scrollIntoView) {
//         collectionWrapper.scrollIntoView({ behavior: 'smooth' });
//         collectionWrapper.classList.add('visible');
//       }
//     } else {
//       // For reset (q === ''), force a clean page load with no params.
//       window.location.href = baseUrl();
//     }
//   }

//   function closeDropdowns(event) {
//     selectAll('.plant-finder__string-filters', filtersWrapper).forEach(function (el) {
//       var inside = event && event.composedPath ? event.composedPath().includes(el) : (event && el.contains(event.target));
//       if (!inside) el.classList.remove('active');
//     });
//   }

//   function chooseOption(item) {
//     var wrap = item.closest('.plant-finder__string-filters');
//     var label = wrap ? select('.plant-finder__current-filter span', wrap) : null;
//     if (!wrap || item.classList.contains('active') || !label) return;

//     var current = select('.plant-finder__filter-selector-item.active', wrap);
//     if (current) current.classList.remove('active');

//     item.classList.add('active');
//     wrap.classList.remove('active');
//     label.textContent = item.dataset.value || '';
//     wrap.dataset.filterValue = item.dataset.value || '';
//   }

//   function resetUIOnly() {
//     selectAll('.plant-finder__string-filters', filtersWrapper).forEach(function (fw) {
//       fw.removeAttribute('data-filter-value');
//       var active = select('.plant-finder__filter-selector-item.active', fw);
//       if (active) active.classList.remove('active');
//       var span = select('.plant-finder__current-filter span', fw);
//       if (span && fw.dataset.initialLabel) span.textContent = fw.dataset.initialLabel;
//       fw.classList.remove('active');
//     });
//   }

//   function handleResetClick(e) {
//     var resetEl = e.target.closest ? e.target.closest('.plant-finder__reset') : null;
//     if (!resetEl) return;

//     // Kill anchor jumps or any other handlers that might scroll
//     e.preventDefault();
//     e.stopPropagation();
//     if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

//     // Clear UI + force clean URL (no AJAX here to avoid lingering state)
//     resetUIOnly();
//     applyQuery('');
//   }

//   // Capture-phase reset handler so we intercept even if theme binds later
//   document.addEventListener('click', handleResetClick, true);

//   // Close dropdowns when clicking outside
//   window.addEventListener('click', function (e) { closeDropdowns(e); });

//   // Delegated interactions inside your wrapper
//   filtersWrapper.addEventListener('click', function (e) {
//     var option = e.target.closest && e.target.closest('.plant-finder__filter-selector-item');
//     if (option) return chooseOption(option);

//     var dropdown = e.target.closest && e.target.closest('.plant-finder__string-filters');
//     if (dropdown) dropdown.classList.toggle('active');

//     var submit = e.target.closest && e.target.closest('.plant-finder__submit');
//     if (submit) {
//       e.preventDefault();
//       var q = buildQuery();
//       if (q) applyQuery(q);
//     }
//   });
// })();